
// vue
import { defineComponent } from 'vue';

// atoms
import Modal from '@/components/atoms/Modal.vue';

export default defineComponent({
  name: 'Loader',
  components: {
    Modal,
  },
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
    type: {
      type: String,
      required: false,
    },
  },
  setup(props) {
    return {};
  },
});
